module.exports = __webpack_public_path__ + "img/arr-l-r.7b51746f.png";